import * as Sentry from "@sentry/browser";

import { type User } from "@app_schema";

import { withMixpanel } from "@application/initializers/mixpanel";
import { SENTRY_ENABLED } from "@application/initializers/sentry";

export const identify = (user: Pick<User, "id" | "name" | "email">) => {
  withMixpanel((mixpanel) => {
    mixpanel.identify(user.id);
    mixpanel.people.set({
      $name: user.name,
      $email: user.email,
    });
  });

  if (SENTRY_ENABLED) {
    Sentry.setUser({
      id: user.id,
      username: user.name,
      email: user.email,
    });
  }
};
